import { ReactElement, useCallback } from 'react';
import { OptionProps, GroupBase } from 'react-select';
import { Obj } from 'types/common';
import styles from './select.module.scss';

export function Option<T extends Obj>(
  props: OptionProps<T, false | true, GroupBase<T>>,
  optionValue?: keyof T,
  customOption?: (data: T) => ReactElement | null
): ReactElement | null {
  const { innerProps, getValue, data, children } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { onMouseMove, onMouseOver, ...newInnerProps } = innerProps;
  const [value] = getValue();

  const getOption = useCallback(() => {
    if (customOption) {
      return customOption(data);
    } else return <p>{children}</p>;
  }, [customOption, data, children]);

  return (
    <div
      className={`${styles.option} ${
        value && value[optionValue || 'value'] === data[optionValue || 'value'] && styles.selectedOption
      } `}
      {...newInnerProps}>
      {getOption()}
    </div>
  );
}
